export default "* Samarbejde\n* Helfigur\n* Naturmaterialer\n* Beklædning\n";